import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

window.axios = require('axios');

window.$ = window.jQuery = require('jquery');
require('foundation-sites');

/* try {
  window.$ = window.jQuery = require('jquery');

  require('foundation-sites');
} catch (e) {} */

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
